<div class="identification-page">

    <div class="page-header">

        <div>
          <h1>Placas de identificación</h1>
          <p>
            Gestiona las solicitudes de placas de identificación
            para los animales vinculados con ABAQ.
          </p>
        </div>
      
        <div class="header-actions">
      
          <button
            type="button"
            class="copy-link-button"
            (click)="copyFormLink()"
          >
            🔗 Copiar enlace
          </button>
      
          <button
            type="button"
            class="create-button"
            (click)="openCreateForm()"
          >
            + Nueva placa
          </button>
      
        </div>
      
      </div>
  
  
    @if (showCreateForm) {
  
      <div class="form-card">
  
        <div class="form-header">
  
          <div>
            <h2>Nueva placa de identificación</h2>
  
            <p>
              Registra la información de la placa y del animal.
            </p>
          </div>
  
          <button
            type="button"
            class="close-button"
            (click)="closeCreateForm()"
            [disabled]="isCreating"
          >
            ✕
          </button>
  
        </div>
  
  
        <div class="form-grid">
  
          <div class="form-group">
  
            <div class="form-group">
                <label for="student">
                  Estudiante que vincula
                </label>
              
                <select
                  id="student"
                  [(ngModel)]="selectedStudentId"
                >
                  <option value="">
                    Selecciona un estudiante
                  </option>
              
                  @for (student of students; track student.id) {
                    <option [value]="student.id">
                      {{ student.fullName }}
                      — {{ student.matricula }}
                    </option>
                  }
                </select>
              </div>
  
          </div>
  
  
          <div class="form-group">
  
            <label for="responsibleName">
              Nombre del responsable
            </label>
  
            <input
              id="responsibleName"
              type="text"
              placeholder="Ej. Carlos Hernández"
              [(ngModel)]="responsibleName"
            />
  
          </div>
  
  
          <div class="form-group">
  
            <label for="species">
              Especie
            </label>
  
            <select
              id="species"
              [(ngModel)]="species"
            >
              <option value="DOG">
                Perro
              </option>
  
              <option value="CAT">
                Gato
              </option>
            </select>
  
          </div>
  
  
          <div class="form-group">
  
            <label for="animalName">
              Nombre del animal
            </label>
  
            <input
              id="animalName"
              type="text"
              placeholder="Ej. Max"
              [(ngModel)]="animalName"
            />
  
          </div>
  
  
          <div class="form-group">
  
            <label for="phone">
              Teléfono
            </label>
  
            <input
              id="phone"
              type="tel"
              placeholder="Ej. 4421234567"
              [(ngModel)]="phone"
            />
  
          </div>
  
  
          <div class="form-group">
  
            <label for="plateDesign">
              Diseño de la placa
            </label>
  
            <input
              id="plateDesign"
              type="text"
              placeholder="Ej. Huesito clásico"
              [(ngModel)]="plateDesign"
            />
  
          </div>
  
  
          <div class="form-group">
  
            <label for="material">
              Material
            </label>
  
            <select
              id="material"
              [(ngModel)]="material"
            >
              <option value="STEEL">
                Acero
              </option>
  
              <option value="ALUMINUM">
                Aluminio
              </option>
            </select>
  
          </div>
  
  
          <div class="form-group">
  
            <label for="abaqCost">
              Costo ABAQ
            </label>
  
            <input
              id="abaqCost"
              type="number"
              min="0"
              placeholder="Ej. 80"
              [(ngModel)]="abaqCost"
            />
  
          </div>
  
  
          <div class="form-group">
  
            <label for="providerCost">
              Costo proveedor
            </label>
  
            <input
              id="providerCost"
              type="number"
              min="0"
              placeholder="Ej. 60"
              [(ngModel)]="providerCost"
            />
  
          </div>
  
  
          <div class="form-group form-group-full">
  
            <label for="paymentProofUrl">
              Comprobante de pago
            </label>
  
            <input
              id="paymentProofUrl"
              type="url"
              placeholder="Pega aquí el enlace del comprobante"
              [(ngModel)]="paymentProofUrl"
            />
  
            <small>
              Puedes agregar un enlace de Google Drive,
              OneDrive u otro repositorio.
            </small>
  
          </div>
  
        </div>
  
  
        <div class="form-actions">
  
          <button
            type="button"
            class="cancel-button"
            (click)="closeCreateForm()"
            [disabled]="isCreating"
          >
            Cancelar
          </button>
  
          <button
            type="button"
            class="save-button"
            (click)="createIdentification()"
            [disabled]="
                !selectedStudentId ||
              !responsibleName ||
              !animalName ||
              isCreating
            "
          >
  
            @if (isCreating) {
              Guardando...
            } @else {
              Guardar placa
            }
  
          </button>
  
        </div>
  
      </div>
  
    }
  
  
    @if (isLoading) {
  
      <div class="loading-state">
        Cargando placas...
      </div>
  
    } @else if (identifications.length === 0) {
  
      <div class="empty-state">
  
        <div class="empty-icon">
          🏷️
        </div>
  
        <h2>No hay placas registradas</h2>
  
        <p>
          Cuando registres una placa aparecerá aquí.
        </p>
  
      </div>
  
    } @else {
  
      <div class="identification-grid">
  
        @for (
          identification of pagedIdentifications;
          track identification._id
        ) {
  
          <article class="identification-card">
  
            <div class="card-header">
  
              <div class="animal-info">
  
                <div class="animal-icon">
                  @if (identification.species === 'DOG') {
                    🐶
                  } @else {
                    🐱
                  }
                </div>
  
                <div>
  
                  <h2>
                    {{ identification.animalName }}
                  </h2>
  
                  <span class="species">
                    @if (identification.species === 'DOG') {
                      Perro
                    } @else {
                      Gato
                    }
                  </span>
  
                </div>
  
              </div>
  
  
              <span
                class="status-badge"
                [class.status-completed]="
                  identification.status === 'COMPLETED'
                "
                [class.status-pending]="
                  identification.status === 'PENDING'
                "
              >
                @if (identification.status === 'COMPLETED') {
                  Completada
                } @else {
                  Pendiente
                }
              </span>
  
            </div>
  
  
            <div class="card-content">
  
              <div class="information-grid">
  
                <div class="information-item">
  
                  <span>
                    Responsable
                  </span>
  
                  <strong>
                    {{ identification.responsibleName }}
                  </strong>
  
                </div>
  
  
                <div class="information-item">
  
                  <span>
                    Vinculado por
                  </span>
  
                  <strong>
                    {{ identification.linkerName }}
                  </strong>
  
                </div>
  
  
                <div class="information-item">
  
                  <span>
                    Material
                  </span>
  
                  <strong>
                    @if (identification.material === 'STEEL') {
                      Acero
                    } @else {
                      Aluminio
                    }
                  </strong>
  
                </div>
  
  
                <div class="information-item">
  
                  <span>
                    Diseño
                  </span>
  
                  <strong>
                    {{ identification.plateDesign || 'Sin especificar' }}
                  </strong>
  
                </div>
  
              </div>
  
  
              <div class="cost-section">
  
                <div>
                  <span>
                    Costo ABAQ
                  </span>
  
                  <strong>
                    ${{ identification.abaqCost || 0 }}
                  </strong>
                </div>
  
  
                <div>
                  <span>
                    Costo proveedor
                  </span>
  
                  <strong>
                    ${{ identification.providerCost || 0 }}
                  </strong>
                </div>
  
              </div>
  
            </div>
  
  
            <div class="card-footer">
  
              <span class="created-date">
                Registrada
                {{ identification.createdAt | date:'mediumDate':'UTC' }}
              </span>
  
              <button
                type="button"
                class="view-button"
                (click)="viewIdentification(identification._id)"
              >
                Ver detalle
              </button>
  
            </div>
  
          </article>
  
        }
  
      </div>

      <app-pagination
        [(page)]="page"
        [totalItems]="identifications.length"
        [pageSize]="pageSize"
      ></app-pagination>
  
    }
  
  </div>